import { useState } from "react";

const setMetrics = (key: string, columns: string[]) => {
  const options = localStorage.getItem("metricOptions");
  let parsedOptions = {};
  try {
    parsedOptions = JSON.parse(options!) as Record<string, string[]>;
  } catch {
    // noop
  }
  localStorage.setItem("metricOptions", JSON.stringify({ ...parsedOptions, [key]: columns }));
};

const getMetrics = (key: string, defaults?: string[]) => {
  const options = localStorage.getItem("metricOptions");
  defaults = defaults || [];
  if (options) {
    try {
      return (JSON.parse(options) as Record<string, string[]> | null)?.[key] ?? defaults;
    } catch {
      return defaults;
    }
  }
  return defaults;
};

const useSelectedMetrics = (initialSelectedMetrics: string[], key?: string) => {
  const [selectedMetrics, setSelectedMetrics] = useState(() =>
    key ? getMetrics(key, initialSelectedMetrics) : initialSelectedMetrics,
  );

  const onMetricChange = (changes: string[]) => {
    if (key) {
      setMetrics(key, changes);
    }
    setSelectedMetrics(changes);
  };

  const toggleMetric = (metric: string, force?: boolean) => {
    if (force) {
      if (!selectedMetrics.includes(metric)) {
        onMetricChange([...selectedMetrics, metric]);
      }
    } else if (selectedMetrics.includes(metric)) {
      onMetricChange(selectedMetrics.filter((m) => m !== metric));
    } else {
      onMetricChange([...selectedMetrics, metric]);
    }
  };

  return {
    selectedMetrics,
    toggleMetric,
    setSelectedMetrics,
  };
};

export default useSelectedMetrics;
